module.exports = __webpack_public_path__ + "img/keyan.2b09a24c.png";